module.exports = __webpack_public_path__ + "img/antilopay_card.bebd2b8d.png";